import styled from "styled-components";

type IContainerStyled = {
    isContentEmpty?: boolean;
};

export const CartItemActionsContainer = styled.div({
    display: "block",
    visibility: "visible",
    opacity: 1,
    position: "relative",
});

export const CartItemRelativeContainer = styled.div<{ isContentEmpty?: boolean }>(({ isContentEmpty, theme }) => ({
    position: "initial",
    overflow: "scroll",
    height: isContentEmpty ? theme.spacing.small : "auto",
    maxHeight: "100%",
    minHeight: "100%",
    "-webkit-overflow-scrolling": "touch",
    "-ms-overflow-style": "none", // IE and Edge
    "scrollbar-width": "none", // Firefox
    "&::-webkit-scrollbar": {
        display: "none",
    },
}));

export const ContainerStyled = styled.div<IContainerStyled>(props => {
    return {
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "nowrap",
        padding: props.isContentEmpty
            ? "0px"
            : `${props.theme.spacing.xSmall} ${props.theme.spacing.medium} ${props.theme.spacing.medium}`,
        justifyContent: "left",
        whiteSpace: "pre",
        overflowX: "auto",
        minWidth: "100%",
        overflow: "initial",
        minHeight: "100%",
        // margin for spacing, instead of gap
        "& > *:not(:last-child)": {
            marginRight: props.theme.spacing.xSmall,
        },
    };
});

export const ContainerStyledV1 = styled.div`
    padding-top: ${props => props.theme.spacing.xSmall};
`;
